export const environment = {
  production: true,
  
  apiUrl: "https://umyoespanol.site/api_umyocards/public/api/"
};


